import * as React from 'react';

import {
  cssClass,
  fillStyle,
  flexColumnStyle,
} from '../../style';
import { FlowSubplaceProps } from '../types/FlowSubplaceProps';
import { FlowRunSchedulesGridView } from './FlowRunSchedulesGridView';

const cssPrefix = 'FlowRunSchedulesSubplace';

const rootClass = cssClass(cssPrefix, 'root', fillStyle, flexColumnStyle);

export class FlowRunSchedulesSubplace extends React.PureComponent<FlowSubplaceProps> {

  public render(): JSX.Element {
    return (
      <div className={rootClass}>
        <FlowRunSchedulesGridView
          flowAllowedActions={this.props.flowAllowedActions}
          flowInfo={this.props.flowDetailInfo}
        />
      </div>
    );
  }
}
